import React, { Component } from 'react';

class TermsKR extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <div className="share-container">
        <div className={'tit_policy'}>Terms of service</div>
        <div className={'tit_subject'}>제1조(목적)</div>
        <div>
          이 약관은 (주)아토즈소프트 회사(사이하 '회사')가 운영하는 HALASZ 라 함은 회사가 제공하는 'HALASZ' 브랜드를 사용하는 서비스와
          관련하여 이용조건 및 사용자 권리 및 의무 사항을 규정함을 목적으로 합니다.
          <br />
        </div>
        <div className={'tit_subject'}>제2조(약관의 명시, 효력 및 변경)</div>
        1. 본 약관의 내용은 회사가 제공하는 개별 서비스 또는 서비스 초기 화면에 게시하거나 기타의 방법으로 공지하고, 본 약관에 동의한 모든
        사용자에게 그 효력이 발생합니다.
        <p />
        2. 회사는 필요한 경우 관련 법령을 위배하지 않는 법위 내에서 본 약관을 변경할 수 있습니다. 본 약관이 변경되는 경우 회사는 변경 사항을
        시행일자 15일 전부터 사용자에게 공지 또는 통지하는 것을 원칙으로 하며, 피치 못하게 사용자에게 불리한 내용으로 변경 할 경우에는 그
        시행일자 30일 전부터 가입한 이메일 주소로 이메일을 발송하거나, 알림 메세지를 띄우는 등 합리적으로 가능한 방법으로 변경사항을
        공지합니다.
        <p />
        3. 회사가 전 항에 따라 공지하면서 공지 또는 통지일로부터 개정약관 시행일 7일 후까지 거부의사를 표시하지 아니하면 승안한 것으로
        본다는 뜻을 명확하게 고지하였음에도 사용자의 의사표시가 없는 경우에는 변경된 약관을 승인한 것으로 봅니다.
        <p />
        4. 본 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제에 관한 법률,
        공정거래위원회가 정하는 전자상거래 등에서의 소비자 보호지침 및 관련 법령 또는 일반 상관례에 따릅니다.
        <div className={'tit_subject'}>제3조 (계약의 성립)</div>
        1. 이용 계약은 회사에서 제공하는 서비스를 이용하기 위해 회원이 되고자 하는자가 약관의 내용에 동의를 하고, 회사가 정한 양식에 따라
        회원 정보(이메일주소, 비밀번호 등)을 기입하여 회원가입 신청을 하면, 이용신청에 대한 회사의 이용 승낙으로 성립합니다.
        <p />
        <div className={'tit_subject'}>제4조 (서비스 이용)</div>
        1. 회사는 SNS, 게시판 서비스, 온라인 콘텐츠 제공 서비스, 위치기반서비스 등 사용자가 인터넷과 모바일로 즐길 수 있는 다양한 서비스를
        제공합니다. 사용자는 스마트폰의 어플리케이션 스토어 등에서 서비스를 다운받아 설치하거나 직접 PC에 설치 혹은 웹페이지에 접속하여
        서비스를 이용할 수 있습니다.
        <p />
        2. 회사는 더 나은 서비스를 위하여 서비스에 필요한 소프트웨어의 업데이트 버전을 제공할 수 있습니다. 소프트웨어의 업데이트에는 중요한
        기능의 추가 또는 불필요한 기능의 제거 등이 포함되어 있습니다. 사용자 서비스를 즐겁게 이용할 수 있도록 꾸준히 업데이트를 하여 주시기
        바랍니다.
        <p />
        3. 회사는 더 나은 서비스의 제공을 위하여 여러분에게 서비스의 이용과 관련된 각종 고지, 관리 메시지 및 기타 광고를 비롯한 다양한
        정보를 서비스에 표시하거나 여러분의 메일 계정으로 직접 발송할 수 있습니다.
        <p />
        4. 서비스 이용 중 시스템 오류 등 문제점을 발견하신다면 언제든지 고객 센터로 알려주시기 바랍니다.
      </div>
    );
  }
}

export default TermsKR;
